<template>

<div class="page work">

  <!-- MAIN LANDING SECTION -->
	<transition name="slide-up-in" appear>
	<section id="landing" class="block-image-hero">
		<div class="container">
			<span class="hero-background"></span>
			<ts-image :src="image1.url" :width="image1.size[0]" :height="image1.size[1]" :bg-color="image1.bgColor"></ts-image>
		</div>
	</section>
	</transition>


	<!-- TEXT -->
	<section id="section-1" class="block-text-overview">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-5" data-sal="slide-up" data-sal-delay="600" data-sal-duration="600" data-sal-easing="ease">
					<p class="meta">UX, UI, &amp; Brand</p>
					<h2>Chatamo. Bots</br>For Business</h2>
					<p>Chatamo enables businesses to create intelligent voice and chatbots for marketing, sales and customer support.</p>
					<p>With the emergence of bot technology such as Alexa and bot integration within messenger apps, businesses have an opportunity to communicate better and reach further to customers. By using Chatamo, companies can build one bot to distribute across multiple channels.</p>
					<p>I helped to develop a digital strategy and launch a brand that involved Visual design, UX &amp; UI design and digital marketing.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-2" class="block-image" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
		<div class="container">
			<!-- IMAGE 2 -->
      <ts-image :src="image2.url" :width="image2.size[0]" :height="image2.size[1]" :bg-color="image2.bgColor" dark-loader></ts-image>
		</div>
	</section>


	<!-- TEXT -->
	<section id="section-3" class="block-text-content border">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Customer-Friendly Chat</h3>
					<p>There is a lot of work for businesses to maintain customer services and most frequently asked questions have a simple answer.</p>
					<p>Chatamo's AI can create customer-friendly conversation logic around the question and answer input making for a pleasing, organic feeling experience.</p>
					<p>The intuitive answer creation panel to allow contextual representation of text, images.url, videos, buttons and maps UI.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGES -->
	<section id="section-4" class="block-image multiple">
		<div class="container">
			<span class="background right"></span>
			<!-- IMAGE 3 -->
      <ts-image :src="image3.url" :width="image3.size[0]" :height="image3.size[1]" :bg-color="image3.bgColor"></ts-image>
			<!-- IMAGE 4 -->
      <ts-image :src="image4.url" :width="image4.size[0]" :height="image4.size[1]" :bg-color="image4.bgColor"></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


	<!-- TEXT -->
	<section id="section-5" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Monitor User Activity</h3>
					<p>Businesses need to keep customers happy by fulfiling expectations and answer all customer questions efficiently.</p>
					<p>Monitoring chatbot usage involves keeping on top of languages, daily activity, GDPR requests, the sentiment of conversations and any unanswered questions.</p>
					<p>The usage insight dashboard is designed to alert the user by using colour to highlight positive and negative values.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-6" class="block-image">
		<div class="container">
			<span class="background left"></span>
      <!-- IMAGE 5 -->
      <ts-image :src="image5.url" :width="image5.size[0]" :height="image5.size[1]" :bg-color="image5.bgColor"></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


  <!-- TEXT -->
	<section id="section-7" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>The Chatamo Personality</h3>
					<p>We began by laying the foundations of the brand through colour and typography to capture the initial feel. Not too cheap, not too techy but just right.</p>
				</div>
			</div>
		</div>
	</section>


  <!-- IMAGE -->
	<section id="section-8" class="block-image full multiple">
    <!-- IMAGE 6 -->
    <ts-image :src="image6.url" :width="image6.size[0]" :height="image6.size[1]" :bg-color="image6.bgColor" dark-loader></ts-image>
    <!-- IMAGE 7 -->
    <ts-image :src="image7.url" :width="image7.size[0]" :height="image7.size[1]" :bg-color="image7.bgColor"></ts-image>
    <!-- IMAGE 8 -->
    <ts-image :src="image8.url" :width="image8.size[0]" :height="image8.size[1]" :bg-color="image8.bgColor" dark-loader></ts-image>
	</section>

  <ts-footer></ts-footer>


</div>


</template>


<script>

// @ is an alias to /src
import sal from 'sal.js'
import TsImage from '@/components/TSImage.vue'
import TsFooter from '@/components/TSFooter.vue'

import Image1 from "@/assets/images/works/chatamo/200-image-1.png"
import Image2 from "@/assets/images/works/chatamo/200-image-2.png"
import Image3 from "@/assets/images/works/chatamo/200-image-3.png"
import Image4 from "@/assets/images/works/chatamo/200-image-4.png"
import Image5 from "@/assets/images/works/chatamo/200-image-5.png"
import Image6 from "@/assets/images/works/chatamo/200-image-6.png"
import Image7 from "@/assets/images/works/chatamo/200-image-7.png"
import Image8 from "@/assets/images/works/chatamo/200-image-8.png"

export default {

  name: 'WorksChatamo',

  data() {
    return {
			image1: {
        url: Image1,
        size: [2560, 1356],
        bgColor: "none",
      },
      image2: {
        url: Image2,
        size: [2560,1742],
        bgColor: "none"
      },
      image3: {
        url: Image3,
        size: [2560,1416],
        bgColor: "none"
      },
      image4: {
        url: Image4,
        size: [2560,1986],
        bgColor: "none"
      },
      image5: {
        url: Image5,
        size: [2560,3772],
        bgColor: "none"
      },
      image6: {
        url: Image6,
        size: [2880,1374],
        bgColor: "none"
      },
      image7: {
        url: Image7,
        size: [2880,1374],
        bgColor: "none"
      },
      image8: {
        url: Image8,
        size: [2880,4776],
        bgColor: "none"
      }
    }
  },

  components: {
    TsImage,
    TsFooter
  },

	mounted() {
    this.$root.$emit('show-shapes', false)
		sal({threshold: 0.10});
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@import "~@/assets/scss/_variables";
@import "~@/assets/scss/grid/_bootstrap-grid";

span.hero-background {
	background-color: #1FC8F2;
	background-image: linear-gradient(137deg, #1FC8F2 0%, #39D2E5 20%, #4BD9DB 38%, #409DE0 78%, #3561E5 100%);
}
span.background {
	background-color: #1FC8F2;
	background-image: linear-gradient(137deg, #1FC8F2 0%, #39D2E5 20%, #4BD9DB 38%, #409DE0 78%, #3561E5 100%);
}

</style>
